import { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { applyClassToExistingElements, applyClassToMatchingChildren } from './use-conditional-class-on-dom-elements.utils';

/**
 * A custom hook that applies a class to elements with specified class names based on a given condition.
 *
 * @param {boolean} condition - The condition that determines whether the class should be added or removed.
 * @param {string} className - The class name to apply or remove based on the condition.
 * @param {Array<string>} targetClassNames - An array of class names for elements to which the class should be applied or removed.
 * @param {Object} observerTarget - The target to observe for changes to the DOM.
 */
export default function useConditionalClassOnDomElements(condition, className, targetClassNames) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    observerTarget = _ref.observerTarget;
  if (_isEmpty(targetClassNames)) {
    return;
  }
  useEffect(function () {
    applyClassToExistingElements(condition, className, targetClassNames);
  }, [condition, className, targetClassNames]);
  useEffect(function () {
    var observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(applyClassToMatchingChildren(condition, className, targetClassNames));
        }
      });
    });
    observer.observe(observerTarget || document.body, {
      childList: true,
      subtree: true
    });
    return function () {
      return observer.disconnect();
    };
  }, [condition, className, targetClassNames]);
}